module.exports = __webpack_public_path__ + "static/img/tk.a2ef3b3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/tk.png
// module id = WeZ9
// module chunks = 1